import { render, staticRenderFns } from "./AnswerList.vue?vue&type=template&id=886f9f24&"
import script from "./AnswerList.vue?vue&type=script&lang=js&"
export * from "./AnswerList.vue?vue&type=script&lang=js&"
import style0 from "./AnswerList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports